import { components } from "@certn/api/generated-schemas/client-portal";

import { filterPackageChecksExcludingBundles } from "./package-edit-utils";
import { PackageDetailResponse } from "./types";

export function generateDuplicatePackageName(
  sourceName: string,
  existingNames: string[],
  namePrefix: string
): string {
  const baseName = `${namePrefix}${sourceName}`;
  const existingNameSet = new Set(existingNames);
  if (!existingNameSet.has(baseName)) {
    return baseName;
  }

  let suffix = 2;
  while (existingNameSet.has(`${baseName} (${suffix})`)) {
    suffix += 1;
  }
  return `${baseName} (${suffix})`;
}

export function packageDetailToCreatePayload(
  packageDetail: PackageDetailResponse,
  existingPackageNames: string[],
  availableBundles: components["schemas"]["AccountAvailableBundles"][] = [],
  duplicateNamePrefix: string
) {
  const standaloneChecks = filterPackageChecksExcludingBundles(
    packageDetail.checks,
    packageDetail.bundles || [],
    availableBundles
  );

  return {
    name: generateDuplicatePackageName(
      packageDetail.name,
      existingPackageNames,
      duplicateNamePrefix
    ),
    description: packageDetail.description,
    checks: standaloneChecks.map((check) => ({
      check_type: check.type,
      arguments: check.check_arguments || {},
    })),
    bundles: packageDetail.bundles,
    tag_names: packageDetail.tags.map((tag) => tag.tagValue),
    rubric_id: packageDetail.adjudication_rubric?.id ?? null,
    is_ats_package: packageDetail.is_ats_package ?? false,
    is_api_package: packageDetail.is_api_package ?? false,
    client_input_claims: packageDetail.client_input_claims ?? {},
  };
}
